'use client';
import { AxiosRequestConfig } from 'axios';
import { createContext, useContext } from 'react';

export const AxiosConfigContext = createContext<AxiosRequestConfig>({});

export const useAxiosConfig = (): AxiosRequestConfig =>
  useContext(AxiosConfigContext);
